import TickIcon from 'assets/icons/tick.svg';
import WarningIcon from 'assets/icons/warning.svg';
import InfoCircleIcon from 'assets/icons/infoCircle.svg';

export interface AlertProps {
  type: 'success' | 'warning' | 'error' | 'info';
  hasArrow?: boolean;
  title: string;
  children?: string | React.ReactElement;
}

function Alert(props: AlertProps) {
  return (
    <div className={`ct_alert _${props.type} ${props.hasArrow ? '_hasArrow' : ''}`}>
      <div className="ct_alert-aside">
        <div className="ct_alert-icon">
          {props.type === 'success' ? <TickIcon /> : null}
          {props.type === 'warning' ? <WarningIcon /> : null}
          {props.type === 'error' ? <WarningIcon /> : null}
          {props.type === 'info' ? <InfoCircleIcon /> : null}
        </div>
      </div>
      <div className="ct_alert-content">
        <h3 className="ct_subtitle1">{props.title}</h3>
        <p className="ct_body3">{props.children}</p>
      </div>
    </div>
  );
}

Alert.defaultProps = { ...{} };

export default Alert;
